import { checkXWithRoomSize, checkYWithRoomSize } from './HelpLinesUtils';
// Specification: Sloping Left shape
//
//     2----3
//    /     |
//   /      |
//  /       |
// 1        |
// |        |
// 0--------4
//
export class SlopingShapeLeft {
    getShape() {
        return [
            { point: { x: -1.25, y: 0, z: 0 } },
            { point: { x: -1.25, y: 1, z: 0 }, measurementLabelHidden: true },
            { point: { x: 0, y: 2.4, z: 0 } },
            { point: { x: 1.25, y: 2.4, z: 0 } },
            { point: { x: 1.25, y: 0, z: 0 }, measurementLabelHidden: true }
        ];
    }
    moveHandle(corners, handle, delta, roomDimensions) {
        const { handle: { position: { x, y } } } = handle;
        let newX = x + delta.x;
        let newY = y + delta.y;
        const { minHeight, minWidth } = { minHeight: 1, minWidth: 1 };
        const closestToSibblingHandle = 0.05;
        switch (handle) {
            case corners[0]:
                /*
                 * Horizontal:
                 * Should also move handle 1
                 * Cannot move closer past handle 2
                 * Cannot move closer to handles 3/4 than minWidth
                 */
                newX = Math.min(corners[2].getPosition().x - closestToSibblingHandle, corners[4].getPosition().x - minWidth, newX);
                newX = checkXWithRoomSize(roomDimensions, newX);
                corners[0].moveTo(newX, corners[0].getPosition().y, corners[0].getPosition().z);
                corners[1].moveTo(newX, corners[1].getPosition().y, corners[1].getPosition().z);
                break;
            case corners[1]:
                {
                    /*
                     * Horizontal:
                     * Should also move handle 0
                     * Cannot move closer past handle 2
                     * Cannot move closer to handles 3/4 than minWidth
                     *
                     * Vertical:
                     * Cannot move lower than minHeight if handle 3 is
                     * Should also move handle 2 if handle 3 is lower
                     */
                    newX = Math.min(corners[2].getPosition().x - closestToSibblingHandle, corners[4].getPosition().x - minWidth, newX);
                    const minY = corners[3].getPosition().y < minHeight ? minHeight : closestToSibblingHandle;
                    if (newY <= minY) {
                        newY = minY;
                    }
                    newX = checkXWithRoomSize(roomDimensions, newX);
                    newY = checkYWithRoomSize(roomDimensions, newY);
                    corners[0].moveTo(newX, corners[0].getPosition().y, corners[0].getPosition().z);
                    corners[1].moveTo(newX, newY, corners[1].getPosition().z);
                    corners[2].moveTo(corners[2].getPosition().x, Math.max(newY, corners[3].getPosition().y, minHeight), corners[2].getPosition().z);
                }
                break;
            case corners[2]:
                /*
                 * Horizontal:
                 * Cannot move closer past handle 1
                 * Cannot move closer past handle 3
                 *
                 * Vertical:
                 * Cannot move lower than minHeight
                 * Should also move both or the topmost handle of 1 and 3
                 */
                if (newX < corners[1].getPosition().x + closestToSibblingHandle) {
                    newX = corners[1].getPosition().x + closestToSibblingHandle;
                }
                if (newX > corners[3].getPosition().x - closestToSibblingHandle) {
                    newX = corners[3].getPosition().x - closestToSibblingHandle;
                }
                if (newY <= minHeight) {
                    newY = minHeight;
                }
                newX = checkXWithRoomSize(roomDimensions, newX);
                newY = checkYWithRoomSize(roomDimensions, newY);
                corners[2].moveTo(newX, newY, corners[2].getPosition().z);
                if (corners[1].getPosition().y === corners[3].getPosition().y) {
                    corners[1].moveTo(corners[1].getPosition().x, newY, corners[1].getPosition().z);
                    //handles[3].moveTo(handles[3].getPosition().x, newY);
                }
                else if (corners[1].getPosition().y > corners[3].getPosition().y) {
                    corners[1].moveTo(corners[1].getPosition().x, newY, corners[1].getPosition().z);
                    corners[3].moveTo(corners[3].getPosition().x, Math.min(corners[3].getPosition().y, corners[2].getPosition().y), corners[3].getPosition().z);
                }
                else {
                    corners[3].moveTo(corners[3].getPosition().x, newY, corners[3].getPosition().z);
                    corners[1].moveTo(corners[1].getPosition().x, Math.min(corners[1].getPosition().y, corners[2].getPosition().y), corners[1].getPosition().z);
                }
                break;
            case corners[3]: {
                /*
                 * Horizontal:
                 * Should also move handle 4
                 * Cannot move past handle 2
                 * Cannot move closer to handles 0/1 than minWidth
                 *
                 * Vertical:
                 * Cannot move lower than minHeight if handle 1 is
                 * Should also move handle 2 if handle 1 is lower
                 */
                newX = Math.max(corners[2].getPosition().x + closestToSibblingHandle, corners[0].getPosition().x + minWidth, newX);
                const minY = corners[1].getPosition().y < minHeight ? minHeight : closestToSibblingHandle;
                newY = Math.max(newY, minY);
                newX = checkXWithRoomSize(roomDimensions, newX);
                newY = checkYWithRoomSize(roomDimensions, newY);
                corners[2].moveTo(corners[2].getPosition().x, Math.max(newY, corners[1].getPosition().y, minHeight), corners[2].getPosition().z);
                corners[3].moveTo(newX, newY, corners[3].getPosition().z);
                corners[4].moveTo(newX, corners[4].getPosition().y, corners[4].getPosition().z);
                break;
            }
            case corners[4]: {
                /*
                 * Horizontal:
                 * Should also move handle 3
                 * Cannot move closer past handle 2
                 * Cannot move closer to handles 0/1 than minWidth
                 */
                newX = Math.max(corners[2].getPosition().x + closestToSibblingHandle, corners[0].getPosition().x + minWidth, newX);
                newX = checkXWithRoomSize(roomDimensions, newX);
                corners[3].moveTo(newX, corners[3].getPosition().y, corners[3].getPosition().z);
                corners[4].moveTo(newX, corners[4].getPosition().y, corners[4].getPosition().z);
                break;
            }
            default:
                break;
        }
    }
}
//# sourceMappingURL=SlopingShapeLeft.js.map